module.exports = __webpack_public_path__ + "img/green-circle-table-3.0dc2cd35.png";